export const COLLECTION_TRADE_TAGS = 'tradeTags';
